import DownloadTemplate from './DownloadTemplate'

export default DownloadTemplate
